export default async synchronizer => {
    await synchronizer.$store.dispatch('paprika/tickers');
}
